import axios from "axios";
import { API_URL } from "../../constants";

export const EventNoteAllApi = async (id) => {
    // ApiStatus({ isLoader: true, isError: false, data: null });
    const token = sessionStorage.getItem('LOGIN_TOKEN');
    const code = sessionStorage.getItem('USER_CODE');

    try {
        let res = await axios.get("https://filmwings.com/site/notification/event_all/"+id, {
            headers: {
                'Authorization': "Bearer " + token,
            }
        });
        // ApiStatus({ isLoader: false, isError: false, data: res.data });
    } catch (err) {
        // ApiStatus({ isLoader: false, isError: true, data: null });
    }

}